import { render, staticRenderFns } from "./ModalAnaliseElegibilidadeResumo.vue?vue&type=template&id=187ede0a&lang=pug"
import script from "./ModalAnaliseElegibilidadeResumo.vue?vue&type=script&lang=js"
export * from "./ModalAnaliseElegibilidadeResumo.vue?vue&type=script&lang=js"
import style0 from "./ModalAnaliseElegibilidadeResumo.vue?vue&type=style&index=0&id=187ede0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports